import { ArrowRight, ArrowLeft, type LucideProps } from "lucide-react";
import { useLanguageContext } from "@/contexts/LanguageContext";

interface DirectionalArrowProps extends LucideProps {
  /** "right" pointe → en LTR, ← en RTL. "left" inverse. */
  direction?: "right" | "left";
}

/**
 * Flèche directionnelle qui se retourne automatiquement en RTL.
 * - direction="right" (défaut) : → en français, ← en arabe
 * - direction="left"           : ← en français, → en arabe
 */
export function DirectionalArrow({ direction = "right", ...props }: DirectionalArrowProps) {
  const { isRTL } = useLanguageContext();

  const showRight = direction === "right" ? !isRTL : isRTL;
  return showRight ? <ArrowRight {...props} /> : <ArrowLeft {...props} />;
}
